/* eslint-disable react-hooks/exhaustive-deps */

import ICONS from "../../../../../assets/Icons";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";
import globalText from "../../../../../utils/globalText";
import { globalTextFormat } from "../../../../../utils/globalTextFormat";
import CommonLayout from "../../../../_utils/CommonLayout";
import CommonDestinationAccount from "../../../../_utils/TransactionCommonComponents/CommonDestinationAccount";
import ConfidentialCard from "../../../../_utils/TransactionCommonComponents/ConfidentialCard";
import NameFieldCard from "../../../../_utils/TransactionCommonComponents/NameFieldCard";
import CommonSourceAccount from "../../../../_utils/TransactionCommonComponents/CommonSourceAccount";

const ScheduleInternalTransactionStepSelectAccounts = ({
  txnPayLoad,
  setTxnPayLoad,
  openOwner,
  setOpenOwner,
  isConfidential,
  setIsConfidential,
  handleOwnerSelection,
  handleOpenInternalAccountModal,
  handleScheduleNameChange,
}) => {
  return (
    <div
      className="w-width-full px-padding-md lg:px-padding-base py-padding-md overflow-y-auto"
      style={{ scrollbarWidth: "none" }}
    >
      <CommonLayout>
        <div className="w-width-full lg:max-w-[var(--create-box-width)]">
          <CommonSourceAccount
            type="source"
            modalOpen={openOwner}
            setModalOpen={setOpenOwner}
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            shouldShowAssociatedAccounts={false}
            handleOnAccountSelection={handleOwnerSelection}
          />
        </div>

        {/* header, sub-header, select/edit and associated-accounts options
            all use CommonDestinationAccount's defaults */}
        <div className="w-width-full lg:max-w-[var(--create-box-width)]">
          <CommonDestinationAccount
            transactionPayload={txnPayLoad}
            setTransactionPayload={setTxnPayLoad}
            onSelectAccount={handleOpenInternalAccountModal}
            requiresSourceAccount
            showCreateAccount={false}
            showsBalance={false}
          />
        </div>

        <div className="flex flex-col gap-gap-md w-width-full lg:max-w-[var(--create-box-width)]">
          <NameFieldCard
            title={globalTextFormat(globalText?.SCHEDULE_NAME, [0, 1])}
            placeholder={globalText?.NAME}
            note={globalText?.SCHEDULE_NOTE_MIN_LENGTH}
            fieldName="schedule_name"
            minLength={GlobalConfiguration?.lengthCheckFive}
            mode="strict"
            value={txnPayLoad?.scheduled_name}
            onChange={handleScheduleNameChange}
          />

          <ConfidentialCard
            icon={ICONS.CONFIDENTIAL_TRANSACTION}
            title={globalText?.CREATE_AS_CONFIDENTIAL}
            note={globalText?.CONFIDENTIAL_SCHEDULE_TRANSACTION_NOTE}
            toggleState={isConfidential}
            onToggle={() => setIsConfidential(!isConfidential)}
          />
        </div>
      </CommonLayout>
    </div>
  );
};

export default ScheduleInternalTransactionStepSelectAccounts;
